import {
    Box, Text,
    SimpleGrid
} from "@chakra-ui/react";
import SectionTitle from "../common/SectionTitle";
import Event from "./Event";
import { useTranslation } from "react-i18next";

const EventsList = ({
    events,
    loading,
    onFavoriteToggle,
    title,
    color,
    titleColor,
    noEventsMessage
}) => {
    const { t } = useTranslation("default");
    const defaultNoEventsMessage = t('event.not_found');

    return (
        <Box w={'full'}>
            {title && (
                <SectionTitle>{title}</SectionTitle>
            )}

            <SimpleGrid columns={{ base: 1, sm: 2, md: 3, lg: 4 }} spacing={{ base: '16px', md: '24px' }}>
                {!loading && events.length === 0 ? (
                    <Text fontSize={{ base: '15px', md: '17px' }} lineHeight="1.6" color={"ink.500"} gridColumn="1 / -1">
                        {noEventsMessage || defaultNoEventsMessage}
                    </Text>
                ) : (
                    events.map((event) => (
                        <Event
                            key={event.id}
                            event={event}
                            onFavoriteToggle={onFavoriteToggle}
                        />
                    ))
                )}
            </SimpleGrid>
        </Box>
    );
};

export default EventsList;
